const _collectionSlug = ref<string | null>(null);

export const useCollectionDevTools = () => {
  const registerCollection = (slug: string) => {
    _collectionSlug.value = slug;
  };

  const unregisterCollection = () => {
    _collectionSlug.value = null;
  };

  return {
    activeCollectionSlug: readonly(_collectionSlug),
    registerCollection,
    unregisterCollection,
  };
};
